let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("7sZmN"), load("bgLDW"), load("h7GGc"), load("i0oSV")]).then(() => parcelRequire('fulxh'));